import React from 'react';

export const tabs = [
  {
    icon_type: 'icon',
    name: 'Icons',
    icon: <span className="fas fa-smile select-icon__tabs-item-icons" />,
  },
  {
    icon_type: 'emoji',
    name: 'Emoji',
    icon: <div className="select-icon__tabs-item-emoji">😀</div>,
  },
  {
    icon_type: 'image',
    name: 'Uploaded',
    icon: <span className="fas fa-upload select-icon__tabs-item-upload" />,
  },
];

export const ICON_TYPES = {
  IMAGE: 'image',
  ICON: 'icon',
  EMOJI: 'emoji',
}

/*
  Очередность показа иконок
 */
export const sequenceIcons = [
  'instagram',
  'instagram-square',
  'facebook-square',
  'facebook-f',
  'facebook',
  'youtube',
  'youtube-square',
  'tiktok',
  'twitter',
  'twitter-square',
  'spotify',
  'twitch',
  'telegram',
  'telegram-plane',
  'vk',
  'soundcloud',
  'tumblr-square',
  'tumblr',
  'vimeo-v',
  'vimeo',
  'linkedin-in',
  'linkedin',
  'quora',
  'pinterest',
  'pinterest-p',
  'pinterest-square',
  'discord',
  'deezer',
  'foursquare',
  'google',
  'itunes',
  'itunes-note',
  'reddit',
  'reddit-alien',
  'reddit-square',
  'odnoklassniki',
  'odnoklassniki-square',
]

/*
  Очередность показа emoji
 */
export const sequenceEmoji = [
  '🔥',
  '❤️‍🔥',
  '❤️',
  '💖',
  '💧',
  '⚡',
  '⛔',
  '♻️',
  '🎉',
  '🛑',
  '⚠️',
  '🎁',
  '👍',
  '👎',
  '➡️',
  '🤖',
  '📷',
  '🎥',
  '💎',
  '⭐',
  '🌎',
  '💌',
  '🎵',
  '🐦',
]
